module.exports = __webpack_public_path__ + "static/media/RatRedemption.2f8d2ce3.mp3";